import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AuthService } from 'src/app/core';
import { PaymentAcceptanceStatus } from 'src/app/shared';

@Component({
  selector: 'payment-payment-submit-btn',
  templateUrl: './payment-submit-btn.component.html',
  styleUrls: ['./payment-submit-btn.component.sass'],
})
export class PaymentSubmitBtnComponent implements OnInit {
  @Output('submit') submitEvent: EventEmitter<any> = new EventEmitter();
  @Input('acceptance') acceptance!: PaymentAcceptanceStatus;
  @Input('readyToPay') readyToPay: boolean = false;
  @Input('disabled') disabled: boolean = false;
  @Input() submitTitle!: string;

  constructor(private authService: AuthService) {}

  ngOnInit(): void {}

  public login() {
    this.authService.openAuthBox('login');
  }

  public activate() {
    this.authService.openAuthBox('activation');
  }

  public submit() {
    if (!this.acceptance.isUserActivated && this.acceptance.isUserLoggedIn) {
      return this.activate();
    }

    if (!this.acceptance.isUserActivated && !this.acceptance.isUserLoggedIn) {
      return this.login();
    }

    this.submitEvent.emit({ name: 'submit' });
  }
}
